import React, { useEffect, useState } from 'react';

import Modal from 'components/shared/Modal/Modal';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

import FacilityProviderForm from '../lib/FacilityProviderForm';

const CreateUpdateFacilityProviderForm = ({
  formik,
  isLoading,
  open,
  type,
  handleClose,
  states
}) => {
  const currentState = states.find((state) => state.value == formik.values.bill_state);
  const [selectedState, setSelectedState] = useState(currentState);

  useEffect(() => {
    if (formik.values.facility_state) {
      const state = states.find((s) => s.value == formik.values.facility_state);
      setSelectedState(state);
    } else {
      setSelectedState(undefined);
    }
  }, [formik.values.facility_state]);

  const handleSelectState = (state) => {
    setSelectedState(state);
    formik.setFieldValue('facility_state', state?.value);
  };

  const customModalTitle = (type) => {
    if (type == 'create') {
      return 'New facility';
    }
    if (type == 'update') {
      return 'Update facility';
    }
  };

  return (
    <>
      <Modal
        className="w-full max-w-[800px]"
        isOpen={open}
        handleClose={() => handleClose()}
        title={customModalTitle(type)}
        footerActions={{
          primary: {
            text: type === 'create' ? 'Create facility' : 'Update facility',
            onClick: () => formik.submitForm(),
            loading: isLoading,
            isDisabled: !formik.dirty || isLoading
          }
        }}>
        <FacilityProviderForm
          formik={formik}
          selectedState={selectedState}
          handleSelectState={handleSelectState}
          states={states}
        />
      </Modal>
    </>
  );
};

export default withErrorBoundary(CreateUpdateFacilityProviderForm);
